import { deleteModuleRecords } from '../../../../services/popupApi';

export const api = {
  deleteItems: async (ids, context) => {
    await deleteModuleRecords(context.moduleName, ids);
  },
};
